import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { InviteType } from '../../ShareModal.meta';
import { MarginProps } from '../../../../../../theme/styledProps';
import { Link } from './LegalFooter.styles';
import { PRIVACY_POLICY_URL } from '../../../../../../CommonConstants';
import { useSelector } from 'react-redux';
import { selectTermsAndConditionsUrl } from '../../../../../../CommonSelectors/CommonAreaSelector';

interface Props extends MarginProps {
  inviteType: InviteType;
}

export const LegalFooter = ({ inviteType, ...rest }: Props) => {
  const websiteTermsAndConditionsUrl = useSelector(selectTermsAndConditionsUrl);

  return (
    <Box as="section" {...rest}>
      <Text as="p" fontSize="small" fontWeight={500} color="neutral.400" mb="16">
        {inviteType === InviteType.Compare
          ? 'By completing, sharing and/or providing information via the assessment, you understand, agree and consent to such information and results being shared with the individual(s) who have shared this assessment with you and potentially their financial advisors, the individual(s) with whom you share this assessment and potentially their financial advisor(s), the originating financial advisor, and the financial advisor’s service providers.'
          : 'By completing, sharing and/or providing information via the assessment, you understand, agree and consent to such information and results being shared with the individual(s) with whom you share this assessment, the originating financial advisor, and the financial advisor’s service providers.'}
      </Text>

      <Text as="p" fontSize="small" fontWeight={500} color="neutral.400">
        Need more details or information? You can access Orion&apos;s Privacy Policy{' '}
        <Link as="a" href={PRIVACY_POLICY_URL} target="_blank" rel="noopener">
          [here]
        </Link>{' '}
        and our website Terms and Conditions{' '}
        <Link as="a" href={websiteTermsAndConditionsUrl} target="_blank" rel="noopener">
          [here]
        </Link>
        . By accessing this assessment and these web pages, you hereby agree that the Terms and
        Conditions apply to your use. Questions can be sent{' '}
        <Link as="a" href="mailto:financialplanning@orion.com">
          [here]
        </Link>
        .
      </Text>
    </Box>
  );
};
